// @flow strict
import { SUPPORTED_LOCALES } from '../../../etc/appConfig.js';
import type { Destination } from '../records/Destination.js';
import type { Poi } from '../records/Poi.js';
import type { SectionConfig } from '../records/SectionConfig.js';
import type { Language } from './intl/context.js';

const createLocaleMap = <T>(factory: () => T): { [Language]: T } =>
  SUPPORTED_LOCALES.reduce((result, locale) => {
    result[locale] = factory();
    return result;
  }, {});

export const createEmptyConfigsByLocale = (): { [Language]: SectionConfig } =>
  createLocaleMap(() => ({ Categories: [], Tags: [] }));

export const createEmptyDestinationsByLocale = (): { [Language]: Destination[] } =>
  createLocaleMap(() => []);

export const createEmptyPoisByLocale = (): { [Language]: Poi } =>
  createLocaleMap(() => ({
    name: '',
    urlName: '',
    objectID: '0',
    breadcrumbDestination: 0,
    toursCount: 0,
    searchRankingScore: 0,
    displayPoiGroupId: 0,
    index: [],
    ratings: [],
  }));
